/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineExtraStayDetailsDto } from './traveline-extra-stay-details-dto';
import {
    TravelineExtraStayDetailsDtoFromJSON,
    TravelineExtraStayDetailsDtoFromJSONTyped,
    TravelineExtraStayDetailsDtoToJSON,
    TravelineExtraStayDetailsDtoToJSONTyped,
} from './traveline-extra-stay-details-dto';

/**
 * 
 * @export
 * @interface TravelineExtraStayDto
 */
export interface TravelineExtraStayDto {
    /**
     * 
     * @type {TravelineExtraStayDetailsDto}
     * @memberof TravelineExtraStayDto
     */
    earlyArrival?: TravelineExtraStayDetailsDto;
    /**
     * 
     * @type {TravelineExtraStayDetailsDto}
     * @memberof TravelineExtraStayDto
     */
    lateDeparture?: TravelineExtraStayDetailsDto;
}

/**
 * Check if a given object implements the TravelineExtraStayDto interface.
 */
export function instanceOfTravelineExtraStayDto(value: object): value is TravelineExtraStayDto {
    return true;
}

export function TravelineExtraStayDtoFromJSON(json: any): TravelineExtraStayDto {
    return TravelineExtraStayDtoFromJSONTyped(json, false);
}

export function TravelineExtraStayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineExtraStayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'earlyArrival': json['earlyArrival'] == null ? undefined : TravelineExtraStayDetailsDtoFromJSON(json['earlyArrival']),
        'lateDeparture': json['lateDeparture'] == null ? undefined : TravelineExtraStayDetailsDtoFromJSON(json['lateDeparture']),
    };
}

  export function TravelineExtraStayDtoToJSON(json: any): TravelineExtraStayDto {
      return TravelineExtraStayDtoToJSONTyped(json, false);
  }

  export function TravelineExtraStayDtoToJSONTyped(value?: TravelineExtraStayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'earlyArrival': TravelineExtraStayDetailsDtoToJSON(value['earlyArrival']),
        'lateDeparture': TravelineExtraStayDetailsDtoToJSON(value['lateDeparture']),
    };
}

